import User from './UserDetailPage';

export default User;
